import "./header.css";
import { FaBars} from "react-icons/fa";

const Header = () => {
  return (
    <header>
      <div className="Container clearfix">
        <div className="segment">
          <div className="headerSegment clearfix">
            <div className="logoSection">
              <div className="bg"></div>
              <div className="logo">
                <a href="https://www.astrologerankitsharma.com/">
                  <img
                    src="https://www.astrologerankitsharma.com/images/logo.png"
                    alt="ASTROLOGER ANKIT SHARMA"
                  />
                </a>
              </div>
            </div>
            <div className="logoRightContainer">
              <div className="segment">
                <div className="background"></div>
                <div className="todayHoro">
                  <h6><a href="https://www.astrologerankitsharma.com/today-horoscope/">Today's Horoscope</a></h6>
                </div>
                <div className="topLinksSegment">
                  <ul className="clearfix">
                    <li>
                      <a href="https://www.astrologerankitsharma.com/why-ankit-sharma-astrologer.html">
                        Why Ankit Ji
                      </a>
                    </li>
                    <li>
                      <a href="https://www.astrologerankitsharma.com/counseling.html">
                        Counseling
                      </a>
                    </li>
                    <li>
                      <a href="https://www.astrologerankitsharma.com/awards-achievements/">
                        Awards
                      </a>
                    </li>
                    <li>
                      <a href="https://www.astrologerankitsharma.com/yantra/">
                        Yantras
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="ctaWrapper clearfix">
                  <div className="mailUs">
                    <a href="mailto:info@astrologerankitsharma.com">
                      info@AstrologerAnkitSharma.com
                    </a>
                  </div>
                  <div className="callUs">
                    <b>Call/WhatsApp</b>
                    <span>
                      <a href="tel:+91-98154-18307" className="tel">
                        +91-98154-18307
                      </a>
                      <img
                        src="https://www.astrologerankitsharma.com/images/indiaFlag.png"
                        width="35"
                        height="35"
                        alt="India"
                      />
                    </span>
                    <span>
                      <a href="tel:+44-7452-214792" className="tel">
                        +44-7452-214792
                      </a>
                      <img
                        src="https://www.astrologerankitsharma.com/images/ukFlag.png"
                        width="35"
                        height="35"
                        alt="UK"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="navSegment">
            <nav className="mainNavigation clearfix">
              <button id="pull">
                Convert Sadness into Happiness !
                <span>
                  Menu <FaBars color={"white"} />
                </span>
              </button>
              <ul className="clearfix">
                <li>
                  <a href="https://www.astrologerankitsharma.com/">Home</a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/whos-is-pandit-ankit-sharma-atrologer.html">
                    Who is Astrologer Ankit Sharma
                  </a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/astrology-specialist/">
                    Astrology Specialist
                  </a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/best-astrologer.html">
                    Best Astrologer
                  </a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/love-specialist-astrologer.html">
                    Love Astrologer
                  </a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/worldwide-astrology-services/">
                    Worldwide Astro Services
                  </a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/love-horoscopes/">
                    Love Horoscopes
                  </a>
                </li>
                <li>
                  <a href="https://www.astrologerankitsharma.com/contact.html">
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
